import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import FlagstoneTheme from '../../config/flagstoneTheme';

import { FilePicker } from 'react-file-picker';
import { dataService } from '../../services/data/data.service';

import AutorenewIcon from '@mui/icons-material/Autorenew';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BarWave from "react-cssfx-loading/lib/BarWave";
import { HubConnectionBuilder } from '@microsoft/signalr';
import { Link } from 'react-router-dom'
import DateRangeIcon from '@mui/icons-material/DateRange';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

export default function TransformPage(props) {
    const classes = useStyles();
    const [excelToProcess, setExcelToProcess] = useState(null);
    const [processedExcel, setProcessedExcel] = useState(null);
    const [transforming, setTransforming] = useState(null);
    const [downloadStart, setDownloadStarted] = useState(null);
    const [transformFailed, setTransformFailed] = useState(false);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);
    const [customerId, setCustomerId] = useState(null);



    useEffect(() => {
        let year = new Date().getFullYear();
        let tempyears = [];
        dataService.getUser(props.user.userid).then(response => {
            setCustomerId(response.data.customerId);
        }, error => {
                console.log("failed fetching user");
            }
        );
        for (let i = year - 5; i < year + 2; i++) {
            tempyears.push(i);
        }

        setYears(tempyears);
        const newHubConnection = new HubConnectionBuilder()
            .withUrl(props.appSettings.DATATRANSFORM_HUB_URL)
            .withAutomaticReconnect()
            .build();
        newHubConnection.on('ReceiveMessage', message => {
            console.log("From transform hub: ")
            console.log(message);
            if (!message.succeeded) {
                setTransformFailed(true)
                setTransforming(false)
            } else {
            }
        });
        newHubConnection.start().then(_ => {
            console.log('Transform connected!');
        }).catch(e => console.log('Transform connection failed: ', e));
        setTransforming(false)
    }, [props.appSettings.DATATRANSFORM_HUB_URL])

    const handleDateChange = (event) => {
        // setFirstLevel(true);
        setSelectedYear(event.target.value);
        // getReportdataByCityAndYear(selectedCities, event.target.value);
    };
    const copyExcelToDestination = async (file) => {
        let tempFileName = file.name;
        var blob = file.slice(0, file.size);
        let newFile = new File([blob], customerId + '^_^' + selectedYear + '^_^' + tempFileName);
        setExcelToProcess(newFile);
    }

    const transformExcel = () => {
        setTransforming(true);
        dataService.uploadExcel(excelToProcess).then(

        );
    }

    const resetAll = () => {
        setTransforming(null)
        setProcessedExcel(null)
        setDownloadStarted(null)
        setExcelToProcess(null)
    }

    const setProcessedFileDownloadable = (message) => {
        setTransforming(false)
        setProcessedExcel(message)
    }

    const downloadStarted = () => {
        setDownloadStarted(true)
    }

    return <div className={classes.firstPage}>
        <div className={classes.resetContainer}>
            <button className={props.user.isInterCommunales ? classes.resetButton : classes.resetDisabled} onClick={() => resetAll()} disabled={!props.user.isInterCommunales}>
                <RestartAltIcon></RestartAltIcon>
                <div className={classes.resetButtonText}>RESET</div>
            </button>
        </div>
        <div className={classes.container}>
            <div className={classes.block}>

                <div className={props.user.isInterCommunales ? classes.button : classes.disabled} disabled={!props.user.isInterCommunales}>
                    {excelToProcess !== null ?
                        <CheckCircleIcon sx={{ fontSize: 80 }} className={classes.circleDone}></CheckCircleIcon>
                        : ''}
                    <div className={classes.title}>
                        Stap 1
                    </div>

                    <div>
                        <DateRangeIcon sx={{ fontSize: 150 }} className={classes.DownloadIcon}></DateRangeIcon>
                        <TextField
                            id="select"
                            label={"Jaartal"}
                            select
                            variant={'filled'}
                            value={selectedYear}
                            onChange={handleDateChange}
                            MenuProps={{ style: { maxHeight: 400, disableScrollLock: true, } }}
                            className={classes.yearDropdown}
                            InputProps={{ disableUnderline: true }}

                        >
                            {
                                years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)
                            }
                        </TextField>
                    </div>
                </div>
                <div className={classes.extraInfo}>
                    <span className={classes.stepDescription}>
                        {"Stap 1: Kies het correcte jaartal voor je registraties"}
                    </span>


                </div>
            </div>
            <div className={classes.block}>
                <FilePicker
                    className={classes.filePicker}
                    extensions={['xlsx']}
                    mode="pickAndStore"
                    onChange={FileObject => copyExcelToDestination(FileObject)}
                    onError={errMsg => (console.log(errMsg))}
                    disabled={!props.user.isInterCommunales}>
                    <button className={props.user.isInterCommunales ? classes.button : classes.disabled} disabled={!props.user.isInterCommunales}>
                        {excelToProcess !== null ?
                            <CheckCircleIcon sx={{ fontSize: 80 }} className={classes.circleDone}></CheckCircleIcon>
                            : ''}
                        <div className={classes.title}>
                            Stap 2
                        </div>
                        <div>
                            <img className={classes.img} alt={"excel"} src={process.env.PUBLIC_URL + '/img/excelIcon.svg'}></img>
                        </div>
                    </button>
                </FilePicker>
                <div className={classes.extraInfo}>
                    <span className={classes.stepDescription}>
                        {"Stap 2: Kies je bestand"}
                    </span>
                    {excelToProcess !== null ?
                        <span className={classes.stepDescriptionExtra}>
                            {"U hebt"} '{excelToProcess.name}' {"gekozen"}
                        </span>
                        : ''
                    }
                </div>
            </div>

            <div className={classes.block}>
                <button className={(excelToProcess === null) ? classes.disabled : (processedExcel !== null ? classes.uploaded : classes.button)} disabled={(excelToProcess === null) ? true : (processedExcel !== null ? true : false)} onClick={() => transformExcel()} >
                    {processedExcel !== null ?
                        <CheckCircleIcon sx={{ fontSize: 80 }} className={classes.circleDone}></CheckCircleIcon>
                        : ''}
                    {transformFailed === true ?
                        <CancelIcon sx={{ fontSize: 80 }} className={classes.circleFailed}></CancelIcon>
                        : ''}
                    <div className={classes.title}>
                        Stap 3
                    </div>
                    <div>
                        <AutorenewIcon sx={{ fontSize: 150 }} className={classes.autorenewIcon}></AutorenewIcon>
                    </div>
                </button>
                <div>
                    <div className={classes.extraInfo}>

                        <span className={classes.stepDescription}>
                            {"Stap 3: Maak Matis bestand "}
                        </span>
                        {processedExcel !== null ?
                            <span className={classes.stepDescriptionExtra}>
                                {"Uw bestand werd verwerkt."}
                            </span>
                            : ''
                        }
                    </div>
                </div>
            </div>

            <div className={classes.block}>
                <Link to={processedExcel ? '/processed/' + processedExcel : ''} target="_blank" download
                    disabled={processedExcel !== null ? true : false}
                    onClick={processedExcel !== null ?
                        () => downloadStarted() :
                        (event) => event.preventDefault()
                    }
                    className={(processedExcel === null) ? classes.disabled : classes.button} >
                    {downloadStart === true ?
                        <CheckCircleIcon sx={{ fontSize: 80 }} className={classes.circleDone}></CheckCircleIcon>
                        : ''}
                    <div className={classes.title}>
                        Stap 4
                    </div>
                    <div>
                        <DownloadIcon sx={{ fontSize: 150 }} className={classes.DownloadIcon}></DownloadIcon>
                    </div>
                </Link>
                <div className={classes.extraInfo}>
                    <span className={classes.stepDescription}>
                        {"Stap 4: Bekijk Matis bestand"}
                    </span>
                </div>
            </div>
        </div>
        {transforming && processedExcel === null &&
            <div className={classes.overlay}>
                <React.Fragment>
                    <div className={classes.transformingOverlay}>
                    </div>
                    <div className={classes.centerLoading}>
                        <div className={classes.transforming}>{"Eventjes geduld"}</div>
                        <BarWave color="#1F8FA5" width="100px" height="40px"></BarWave>
                    </div>

                </React.Fragment>

            </div>
        }
    </div>
}

const useStyles = makeStyles({
    firstPage: {
        height: "calc(100vh - 105px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: 'column',
    },
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        
    },
    title: {
        marginBottom: "30px",
        fontFamily: "Campton-bold",
        fontSize: "20px"

    },
    block: {
        display: "flex",
        flexDirection: "column",
        width: '17%',
    },
    disabled: {
        outline: "none",
        border: "none",
        backgroundColor: "#cccccc",
        cursor: "not-allowed",
        height: '300px',
        width: '100%',
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textDecoration: "none",
        marginBottom: "15px",
        '&:hover': {
            textDecoration: 'none !important',
            color: "white",
        }


    },
    yearDropdown: {
        width: '80%',
        color: 'white',
        backgroundColor: 'white',
        '& .MuiFilledInput-root': {
            border: '1px solid #e2e2e1',
            overflow: 'hidden',
            borderRadius: 4,
            backgroundColor: 'white',

        },
        '&:hover': {
            backgroundColor: 'white'
        },
        '&.Mui-focused fieldset': {
            backgroundColor: 'green',
        },

    },
    button: {
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "100%",
        height: "300px",
        color: "white",
        textDecoration: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        marginBottom: "15px",
        '&:hover': {
            textDecoration: 'none !important',
            color: "white",
        }

    },
    uploaded: {
        outline: "none",
        border: "none",
        cursor: "not-allowed",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "300px",
        height: "300px",
        margin: "5px 50px",
        color: "white",
        textDecoration: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        marginBottom: "15px",

    },

    stepDescription: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#616A6E",
    },
    stepDescriptionExtra: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#616A6E",
    },
    autorenewIcon: {
        fontSize: '80px',
    },
    img: {
        color: "white",
        width: "150px"
    },
    transformingOverlay: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: 'black',
        opacity: "0.8",
        width: "100%",
        height: "100%",
        zIndex: "10",
        position: "fixed",
        top: "0",
        left: "0",
        justifyContent: "center",
        alignItems: "center",
    },
    centerLoading: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "11",
        position: "relative",
        bottom: "22%"

    },
    overlay: {
        top: '0',
        left: '0',
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: '1001',
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'center',
    },
    transforming: {
        marginBottom: '50px',
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        color: "white",
    },
    circleDone: {
        position: "absolute",
        top: "-60px",
        right: "-40px",
        fontSize: "80px",
        color: "green",

    },
    circleFailed: {
        position: "absolute",
        top: "-60px",
        right: "-40px",
        fontSize: "80px",
        color: "red",

    },
    extraInfo: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '50px'
    },
    resetButton: {
        fontSize: '20px',
        fontFamily: "Lato, sans-serif",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        padding: "10px 15px",
        color: "white",
        textDecoration: "none",
        alignItems: "center",
        position: "relative",
        display: "flex",
    },
    resetDisabled: {
        fontSize: '20px',
        fontFamily: "Lato, sans-serif",
        outline: "none",
        border: "none",
        backgroundColor: "#cccccc",
        cursor: "not-allowed",
        padding: "10px 15px",
        color: "white",
        textDecoration: "none",
        alignItems: "center",
        position: "relative",
        display: "flex",
    },
    resetButtonText: {
        paddingTop: "3px"
    },
    resetContainer: {
        alignItems: 'end',
        justifyContent: 'end',
        display: 'flex',
        width: '80%',
        marginBottom: '60px',
    },
});
